/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import ScreenQuestion from "./screens/screenQuestion";
import ScreenStart from "./screens/screenStart";

import styles from "./Styles.module.scss";

const Component = ({ data }) => {
  const [startScreen, setStartScreen] = useState(true);

  useEffect(() => {
    let dataLocal = null;

    if (typeof window !== "undefined") {
      dataLocal = localStorage.getItem("belizeTaxMiniTool");
    }
    if (dataLocal && startScreen == true) {
      setStartScreen(false);
    }
  }, []);

  useEffect(() => {
    const hours = 12; // Reset when storage is more than 3days
    const now = new Date().getTime();
    const setExpirationDate = localStorage.getItem("setExpirationDate");

    if (setExpirationDate === null) {
      localStorage.setItem("setExpirationDate", now);
    } else {
      if (now - setExpirationDate > hours * 60 * 60 * 1000) {
        localStorage.clear();
        localStorage.setItem("setExpirationDate", now);
      }
    }
  });

  return (
    <>
      <div className={`container min-h-screen ${styles.wrapper} `}>
        {startScreen ? (
          <ScreenStart setStartScreen={setStartScreen} />
        ) : (
          <ScreenQuestion setStartScreen={setStartScreen} data={data} />
        )}
      </div>
    </>
  );
};

export default Component;
